var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "composer-menu-area" },
    [
      _c("journey-builder-menu-brick-composer", {
        on: {
          "add-brick": function($event) {
            return _vm.$emit("add-brick", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("journey-builder-menu-edit-form", {
        ref: "editForm",
        attrs: {
          "journey-name": _vm.journeyName,
          "journey-world": _vm.journeyWorld,
          "journey-description": _vm.journeyDescription,
          "journey-start-date": _vm.journeyStartDate,
          "journey-end-date": _vm.journeyEndDate,
          "journey-is-active": _vm.journeyIsActive,
          "journey-division-id": _vm.journeyDivisionId
        },
        on: {
          "update:journeyName": function($event) {
            return _vm.$emit("update:journeyName", $event)
          },
          "update:journeyWorld": function($event) {
            return _vm.$emit("update:journeyWorld", $event)
          },
          "update:journeyDescription": function($event) {
            return _vm.$emit("update:journeyDescription", $event)
          },
          "update:journeyStartDate": function($event) {
            return _vm.$emit("update:journeyStartDate", $event)
          },
          "update:journeyEndDate": function($event) {
            return _vm.$emit("update:journeyEndDate", $event)
          },
          "update:journeyIsActive": function($event) {
            return _vm.$emit("update:journeyIsActive", $event)
          },
          "update:journeyDivisionId": function($event) {
            return _vm.$emit("update:journeyDivisionId", $event)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "button-area" }, [
        _vm.showSaveButton
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary btn-save",
                class: { disabled: !_vm.isValidForm },
                attrs: { type: "submit" },
                on: { click: _vm.saveClick }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(
                  _vm._s(
                    _vm.resource("JourneyBuilder_Index_SaveButton_DisplayText")
                  ) + "\n        "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showUnlockButton
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary btn-unlock",
                class: { disabled: !_vm.isValidForm },
                attrs: { type: "submit" },
                on: { click: _vm.unlockClick }
              },
              [
                _c("i", { staticClass: "fa fa-lock" }),
                _vm._v(
                  _vm._s(
                    _vm.resource(
                      "JourneyBuilder_Shared_UnlockButton_DisplayText"
                    )
                  ) + "\n        "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showCloneButton
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary ml-2",
                on: { click: _vm.cloneClick }
              },
              [
                _c("i", { staticClass: "fas fa-clone" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.resource(
                        "JourneyBuilder_Shared_CloneButton_DisplayText"
                      )
                    ) +
                    "\n        "
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }